var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"horizontal-progress"},[_c('span',{staticClass:"horizontal-progress__percentage",style:({width: (_vm.percents + "%")})}),_vm._v(" "),_c('p',{staticClass:"horizontal-progress__subtitle"},[_vm._v(_vm._s(_vm.subtitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }